import { useMemo } from 'react';

import { parseMinItemsForStatusFromSchema, useFormSchema } from '@/modules/validators';

export const useCollaboratorsValidation = () => {
  const { jSchema } = useFormSchema();
  const collaboratorsSchema = jSchema?.properties?.collaborators;

  const minCollaboratorsByStatus = useMemo(() => {
    return collaboratorsSchema ? parseMinItemsForStatusFromSchema(collaboratorsSchema) : null;
  }, [collaboratorsSchema]);

  return { isCollaboratorsEnabled: Boolean(collaboratorsSchema), minCollaboratorsByStatus };
};
